module.exports = __webpack_public_path__ + "static/img/14.3b60678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/14.png
// module id = ngDo
// module chunks = 0